import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetTotalAdmissionsRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetTotalAdmissionsResponseDtoSchema = z.object({
  marketMedian: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetTotalAdmissionsRequestDto = z.infer<
  typeof _GetTotalAdmissionsRequestDtoSchema
>;
export type GetTotalAdmissionsResponseDto = z.infer<
  typeof GetTotalAdmissionsResponseDtoSchema
>;

export const getTotalAdmissionsKpi = async (
  params: GetTotalAdmissionsRequestDto,
  config?: AxiosRequestConfig<GetTotalAdmissionsRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/total-admissions-kpi`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetTotalAdmissionsResponseDtoSchema));
};
